import semver from 'semver/preload';

export const formatFederationVersion = (
  federationVersion: string | undefined,
) => {
  let semveredFedVersion;
  switch (federationVersion) {
    case null:
      return '';
    case undefined:
      return '';
    default:
      // It's already in the FED_X_Y format
      if (federationVersion.startsWith('FED')) {
        return federationVersion;
      }
      semveredFedVersion = semver.parse(semver.coerce(federationVersion));
      if (!semveredFedVersion) {
        return '';
      }
      return `FED_${semveredFedVersion.major}_${semveredFedVersion.minor}`;
  }
};
